import React, { useEffect, useRef, useState } from "react";

const noOp = () => {};

const MeetingRating = ({
  numberOfStars = 5,
  initialRating = 0,
  onRatingChanged = noOp,
  className,
}) => {
  const [rating, setRating] = useState(initialRating);
  const ratingRef = useRef();

  // Re-render if the initialRating prop is updated from outside
  useEffect(() => setRating(initialRating), [initialRating]);

  useEffect(() => {
    updateActiveStars(rating);
  }, [rating]);

  const hoverHandler = (e) => {
    updateActiveStars(e.target.dataset.value);
  };

  const onMouseOutHandler = (e) => {
    updateActiveStars(rating);
  };

  const starClickHandler = (e) => {
    const rating = e.target.dataset.value;
    setRating(rating);
    onRatingChanged(rating);
  };

  const updateActiveStars = (rating) => {
    const stars = ratingRef.current.querySelectorAll(".star");
    Array.from(stars).forEach((star) => {
      rating >= star.dataset.value
        ? star.classList.add("filled")
        : star.classList.remove("filled");
    });
  };

  return (
    <div className={`meeting-rating ${className}`}>
      <span>RATE THIS MEETING</span>
      <div
        className="meeting-rating-stars"
        ref={ratingRef}
        onMouseOut={onMouseOutHandler}
      >
        {[...Array(+numberOfStars).keys()].map((n) => {
          return (
            <span
              className="star"
              key={n + 1}
              data-value={n + 1}
              onMouseOver={hoverHandler}
              onClick={starClickHandler}
            >
              &#9733;
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default MeetingRating;
